import React from 'react';
import PropTypes from 'prop-types';
import { CLAIM_TYPES } from '../../helpers';
import {
  ProgressContainer,
  ProgressIndicatorBg,
  ProgressIndicator,
  Statuses,
  StatusText,
  Dates
} from './styled';
import { generateStepDates, generateStepTexts, getBoldStatusIndex } from './helpers';
import useClaimProgression from '../../hooks/useClaimProgression';

const ClaimProgressBar = ({ claim }) => {
  const { claimType, statusUpdates } = claim;
  const { progress, isDeclined, isDraft, latestStatusUpdate } =
    useClaimProgression(claim);

  const boldStatusIndex = getBoldStatusIndex(progress);
  const isGuaranteeOfPayment = claimType === CLAIM_TYPES.GUARANTEE_OF_PAYMENT;

  const stepDates = generateStepDates(statusUpdates, isGuaranteeOfPayment);
  const stepTexts = generateStepTexts(
    isDraft,
    isGuaranteeOfPayment,
    isDeclined,
    latestStatusUpdate?.status
  );

  return (
    <ProgressContainer>
      <ProgressIndicatorBg>
        <ProgressIndicator percentage={progress.percentage} />
      </ProgressIndicatorBg>
      <Statuses>
        <StatusText $isBold={boldStatusIndex === 0} $isPast={!isDraft}>
          {stepTexts.first}
        </StatusText>
        <StatusText
          $isBold={boldStatusIndex === 1}
          $isPast={progress.percentage >= 50 && !isGuaranteeOfPayment}
          $isDeclined={isDeclined}
        >
          {stepTexts.second}
        </StatusText>
        <StatusText $isBold={boldStatusIndex === 2} $isPast={progress.percentage === 100}>
          {!isDeclined && stepTexts.third}
        </StatusText>
      </Statuses>
      <Dates>
        <StatusText $isBold={boldStatusIndex === 0}>{stepDates.first}</StatusText>
        <StatusText $isBold={boldStatusIndex === 1}>
          {progress.percentage >= 50 && stepDates.second}
        </StatusText>
        <StatusText $isBold={boldStatusIndex === 2}>
          {progress.percentage >= 75 && stepDates.third}
        </StatusText>
      </Dates>
    </ProgressContainer>
  );
};

ClaimProgressBar.propTypes = {
  claim: PropTypes.object.isRequired
};
export default ClaimProgressBar;
